import { formAxios, axios, path } from './config';
import qs from 'qs';
import config from 'config';
import { productTypes, APP_NAME } from 'appConstants';

export function addTagApi({ tagName, isReports }) {
  const params = {
    tag_name: tagName,
  };

  if (isReports) {
    params.include_in_reports = isReports;
  }

  return axios.post(path.ADD_TAGS + qs.stringify({ ...params }));
}

export function updateTagApi({ tagName, isReports, tagId }) {
  const params = {
    tag_name: tagName,
    tag_id: tagId,
  };

  if (isReports) {
    params.include_in_reports = isReports;
  }
  return axios.post(path.UPDATE_TAGS + qs.stringify({ ...params }));
}

export function deleteTagApi({ tagName }) {
  const params = {
    tag_name: tagName,
  };

  return axios.post(path.REMOVE_TAG + qs.stringify({ ...params }));
}

export function removeMultipleSelectedApiTags({ candidateIds, tagName, customerId }) {
  const params = {
    account_id: customerId,
  };

  const data = {
    candidate_ids: candidateIds.join(),
    tag_name: tagName,
    app_name: APP_NAME,
    product: productTypes.TEXT_RECRUIT,
    client_ver: config.clientVersion,
    account_id: customerId,
  };
  return formAxios.post(
    `${path.REMOVE_MULTICANDIDATE_FROM_TAGS}${qs.stringify(params)}`,
    qs.stringify(data),
  );
}
